<template>
	<section id="reference">
		<div id="reference-anchor" class="scroll-to-anchor"></div>

		<div class="left" @click="changeSlide('prev')">
			<div class="box box1"></div>
			<div class="box box2"></div>
			<div class="box box3"></div>
			<div class="arrow">
				<img src="../../assets/icons/arrow.svg" alt="">
			</div>
		</div>
		
		<div class="right" @click="changeSlide('next')">
			<div class="box box1"></div>
			<div class="box box2"></div>
			<div class="box box3"></div>
			<div class="arrow">
				<img src="../../assets/icons/arrow.svg" alt="">
			</div>
		</div>
		
		<div class="slider-wrap" ref="slider">
			<div :class="['slide', activeSlide.id == r.id ? 'active' : '']" v-for="r in references" :key="r.id" :style="{backgroundImage:'url(/static/reference/' + r.image + '.jpg)'}" :ref="'slide-'+r.id">
			</div>  
		</div>

		<div class="text-box">
			<div class="inner">
				<div class="naziv">
					Vrsta dela
				</div> 
				<div class="text-wrapper vrsta_dela">
					<span v-html="activeText.vrsta_dela" ref="text1"></span>
				</div>
			</div>

			<div class="inner">
				<div class="naziv">Objekt</div>
				<div class="text-wrapper">
					<span v-html="activeText.objekt" ref="text2"></span>
				</div>
				
			</div>

			<div class="inner">
				<div class="naziv">Naročnik</div>
				<div class="text-wrapper">
					<span v-html="activeText.narocnik" ref="text3"></span>
				</div>
			</div>
		</div>

	</section>
</template>

<script>
import { TweenMax, Power1, TimelineLite } from "gsap";
import References from "./References.json";

export default {
  data() {
    return {
      references: {},
      activeSlide: {},
      nextSlide: {},
      prevSlide: {},
      activeText: {},
      ww: window.innerWidth,
      wh: window.outerHeight,
      animating: false
    };
  },
  mounted() {
    this.references = References;
    this.activeText = {};
    this.activeSlide = References[0];
    this.activeSlide.index = 0;
    this.nextSlide = References[1];
    this.prevSlide = References[References.length - 1];
    this.activeText = this.activeSlide;

    window.onresize = this.onResize;
  },
  methods: {
    changeSlide(direction) {
      // Transition slide transform left+opacity
      // Transition napisi, slide-out-left, slide-in-from-left
      // Če se ti bo dal lahko nardiš uno foro k se kvadrati izrišejo pa spodi tekst
      // Transition boxov

      if (this.animating) return false;

      this.animating = true;

      const curDOMSlide = this.$refs["slide-" + this.activeSlide.id];

      if (direction == "prev") {
        var nextDOMSlide = this.$refs["slide-" + this.prevSlide.id];
        var nextIndex = this.activeSlide.index - 1;
        if (nextIndex < 0) nextIndex = this.references.length - 1;
      } else {
        var nextDOMSlide = this.$refs["slide-" + this.nextSlide.id];
        var nextIndex = this.activeSlide.index + 1;
        if (nextIndex > this.references.length - 1) nextIndex = 0;
      }

      this.switchBackgrounds(curDOMSlide, nextDOMSlide, direction);
      this.switchContent(nextIndex);
      this.switchBoxes();

      this.activeSlide = this.references[nextIndex];
      this.activeSlide.index = nextIndex;

      this.setNextAndPrevSlides();
    },
    prev() {},
    switchBackgrounds(out, _in, direction) {
      var duration = 1.4;
      var elementInEase = "Power2.easeInOut";
      var elementOutEase = "Power1.easeIn";

      var x = this.ww;

      TweenMax.set(out, { "z-index": 1 });
      TweenMax.set(_in, { "z-index": 4 });

      // Out element

      TweenMax.to(out, duration + 1, {
        x: direction == "prev" ? x * 0.5 : -x * 0.5,
        ease: elementOutEase
      });
      // In element

      TweenMax.fromTo(
        _in,
        duration,
        { x: direction == "prev" ? -x : x },
        {
          x: 0,
          ease: elementInEase,
          onComplete: () => {
            this.animating = false;
          }
        }
      );
    },
    switchContent(refIndex) {
      var ref = this.references[refIndex];
      var textBoxes = [this.$refs.text1, this.$refs.text2, this.$refs.text3];
      TweenMax.to(textBoxes, 0.5, {
        x: -300,
        ease: Power2.easeInOut,
        onComplete: () => {
          this.activeText = ref;
          TweenMax.to(textBoxes, 0.5, { x: 0, ease: Power2.easeInOut });
        }
      });
    },
    switchBoxes() {},
    setNextAndPrevSlides() {
      // Glede na this.activeSlide (.index) določi še prev in next slide
      let nextIndex = this.activeSlide.index + 1;
      let prevIndex = this.activeSlide.index - 1;
      if (this.references[nextIndex])
        this.nextSlide = this.references[nextIndex];
      else this.nextSlide = this.references[0];

      if (this.references[prevIndex])
        this.prevSlide = this.references[prevIndex];
      else this.prevSlide = this.references[this.references.length - 1];
    },
    onResize() {
      this.ww = window.outerWidth;
    }
  },
  computed: {
    activeImage() {
      if (this.activeSlide.image)
        return "url(/static/reference/" + this.activeSlide.image + ".jpg)";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/References/References.vue